/**
 * Stock threshold, mirrored from the API (PROMOTION_LOW_STOCK_THRESHOLD).
 * Used ONLY for the live preview in the product form — the value that counts
 * is always the stock_status returned by the server.
 */
export const PROMOTION_LOW_STOCK_THRESHOLD = 5;

export const PRODUCT_MAX_IMAGES = 8;
export const PRODUCT_IMAGE_MAX_SIZE_BYTES = 5 * 1024 * 1024;
export const PRODUCT_IMAGE_ACCEPTED_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
];

export const STOCK_STATUS = {
  AVAILABLE: "available",
  LOW: "low_stock",
  OUT: "out_of_stock",
};

/** Badge class + label per status. Labels match the API's stock_status_label. */
export const STOCK_STATUS_META = {
  [STOCK_STATUS.AVAILABLE]: {
    label: "Disponible",
    badgeClass: "badge badge-soft-success",
    dotColor: "#0ab39c",
  },
  [STOCK_STATUS.LOW]: {
    label: "Bientôt épuisé",
    badgeClass: "badge badge-soft-warning",
    dotColor: "#f7b84b",
  },
  [STOCK_STATUS.OUT]: {
    label: "Rupture de stock",
    badgeClass: "badge badge-soft-danger",
    dotColor: "#f06548",
  },
};

export const STOCK_STATUS_OPTIONS = [
  { value: "", label: "Tous les statuts" },
  { value: STOCK_STATUS.AVAILABLE, label: "Disponible" },
  { value: STOCK_STATUS.LOW, label: "Bientôt épuisé" },
  { value: STOCK_STATUS.OUT, label: "Rupture de stock" },
];

export const VALIDATION_OPTIONS = [
  { value: "", label: "Toutes les validations" },
  { value: "true", label: "Validés" },
  { value: "false", label: "En attente" },
];

/**
 * Local preview of the status an admin is about to produce.
 * Never sent to the API; the server recomputes it authoritatively.
 */
export const previewStockStatus = (quantity) => {
  const qty = Number(quantity);
  if (!Number.isFinite(qty) || qty <= 0) return STOCK_STATUS.OUT;
  if (qty <= PROMOTION_LOW_STOCK_THRESHOLD) return STOCK_STATUS.LOW;
  return STOCK_STATUS.AVAILABLE;
};

/** Formats a price with thin-space thousands separators: "4 500 FCFA". */
export const formatPrice = (price, currency = "FCFA") => {
  const value = Number(price);
  if (!Number.isFinite(value)) return `${price ?? ""} ${currency}`.trim();
  return `${value.toLocaleString("fr-FR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })} ${currency}`;
};
